export enum messageTypes {
  ERROR = 'error',
  SUCCESS = 'success',
}
